import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageFormComponent } from './message-form/message-form.component';
import { Title } from '@angular/platform-browser';
import { FaviconService } from '../../services/favicon.service';


@Component({
  selector: 'app-landing-page',
  standalone: true,
  imports: [],
  templateUrl: './landing-page.component.html',
  styleUrl: './landing-page.component.scss',
})

export class LandingPageComponent implements OnInit {
  dialog = inject(MatDialog);
  titleService = inject(Title);
  faviconService = inject(FaviconService);

  ngOnInit(): void {
    this.titleService.setTitle('Qima');
    this.faviconService.changeFavicon('assets/images/qima/favicon.ico');
  }

  openFormMessage(solicitation: string): void {
    this.dialog.open(MessageFormComponent , {
      panelClass: 'custom-dialog-container', 
      enterAnimationDuration: '700ms', 
      exitAnimationDuration: '500ms',
      data: { solicitation: solicitation }  
    }
  );
  }
}
